import z from 'zod';

export type TagCategoryDto = {
	id: string;
	name: string;
};

export const TagCategoryDtoSchema: z.ZodType<TagCategoryDto> = z.object({
	id: z.string(),
	name: z.string(),
});
